import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';

import { Perfil } from './../_models/perfil';
import { FiltroPerfil } from 'app/_models/filtro-perfil';

@Injectable()
export class PerfilService extends BaseService {

    headers: Headers;
    private endPoint = '/perfis';
    options: RequestOptions;

    constructor(private http: Http,
        private auth: AuthService, private httpClient: HttpClient) {
        super();
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.options = new RequestOptions({ headers: this.headers });
    }

    obterPerfis(idModulo: string): Observable<Perfil[]> {
        return this.http
            .get(this.urlApi + '/modulos/' + idModulo + '/perfis', this.auth.obterAuthHeader()).pipe(
                map(this.extractData),
                catchError(this.handleError));
    }

    obterPerfil(idPerfil: string): Observable<any> {
        return this.http
            .get(this.urlApi + this.endPoint + '/' + idPerfil, this.auth.obterAuthHeader()).pipe(
                map(this.extractData),
                catchError(this.handleError));
    }

    public getTelas(idModulo: string) {
        return this.http
            .get(this.urlApi + this.endPoint + '/' + idModulo + '/obterTelasAcoes', this.auth.obterAuthHeader())
            .map(this.extractData)
            .catch(this.handleError);
    }

    public obterTodosPerfis(params: string) {
        return this.http
            .get(this.urlApi + this.endPoint + '/todos' + params, this.auth.obterAuthHeader()).pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    public ObterClainsPorUsuarioLogado() {
        return this.http
            .get(this.urlApi + this.endPoint + '/clains-usuario-logado', this.auth.obterAuthHeader()).pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    cadastrar(perfil: Perfil) {
        return this.http
            .post(this.urlApi + this.endPoint, perfil, this.auth.obterAuthHeader())
            .map(this.extractData)
            .catch(this.handleError);
    }

    atualizar(perfil: Perfil) {
        return this.http
            .put(this.urlApi + this.endPoint + '/' + perfil.id, perfil, this.auth.obterAuthHeader())
            .map(this.extractData)
            .catch(this.handleError);
    }

    public obterPerfisFiltro(filters: any, filtro: FiltroPerfil) {
        return this.http
            .post(this.urlApi + this.endPoint + '/filtro' + filters, filtro, this.auth.obterAuthHeader()).pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    public excluir(perfilId: string) {
        return this.http
            .get(this.urlApi + this.endPoint + '/excluir?id=' + perfilId, this.auth.obterAuthHeader()).pipe(
                catchError(this.handleError)
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/perfil.service.ts